export default __webpack_public_path__ + "static/media/lms.46ae88c2.jpg";